import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = 2021;

  const posterImgs = {
    2021: 'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2021/08/FC_Carousel_BWFI-padding.jpg'
  };

  return baseSeoUtil({
    site,
    siteConf,
    title: `Best Workplaces for Innovators 2021`,
    url: `https://www.fastcompany.com/best-workplaces-for-innovators/2021`,
    description: `And when talent and innovation intersect with mission, they can help change the world.`,
    image: posterImgs[year],
    articleSection: 'Best Workplace for Innovators',
    config: state.config
  });
}
